import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "search.small" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M17 17L11.6667 11.6667M13.1111 8.05556C13.1111 8.71946 12.9803 9.37686 12.7263 9.99023C12.4722 10.6036 12.0998 11.1609 11.6304 11.6304C11.1609 12.0998 10.6036 12.4722 9.99023 12.7263C9.37686 12.9803 8.71946 13.1111 8.05556 13.1111C7.39165 13.1111 6.73425 12.9803 6.12088 12.7263C5.50751 12.4722 4.95019 12.0998 4.48074 11.6304C4.01129 11.1609 3.6389 10.6036 3.38483 9.99023C3.13077 9.37686 3 8.71946 3 8.05556C3 6.71474 3.53264 5.42884 4.48074 4.48074C5.42884 3.53264 6.71474 3 8.05556 3C9.39637 3 10.6823 3.53264 11.6304 4.48074C12.5785 5.42884 13.1111 6.71474 13.1111 8.05556Z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }